var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSaveOrange = function SvgSaveOrange(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 80 80"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#save-orange_svg__a)",
    d: "M67.932 38.717a23.689 23.689 0 0 0-2.318-4.454c-.54-.816-.723-1.83-.422-2.761l1.407-4.346c.729-2.251-1.314-4.42-3.605-3.828l-6.404 1.655a3.172 3.172 0 0 1-2.148-.225c-4.011-1.898-8.599-2.975-13.473-2.975-15.742 0-28.503 11.235-28.503 25.094 0 6.724 3.004 12.83 7.894 17.336.656.604 1.06 1.443 1.06 2.335v7.97a3 3 0 0 0 3 3h5.48a2.872 2.872 0 0 0 2.871-2.871c0-1.884 1.788-3.256 3.653-2.992 1.48.208 2.998.317 4.545.317 1.548 0 3.066-.109 4.546-.318 1.866-.263 3.653 1.109 3.653 2.992a2.872 2.872 0 0 0 2.872 2.873h5.479a3 3 0 0 0 3-3v-7.97c0-.893.404-1.732 1.06-2.336 2.072-1.91 3.805-4.106 5.115-6.515.49-.902 1.353-1.56 2.37-1.701l3.565-.494a3 3 0 0 0 2.589-2.971V42.339a3 3 0 0 0-2.589-2.971l-4.697-.65Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M19 46.098S7.465 51.123 4.332 44.839c-1.447-3.966 2.17-6.178 4.484-5.796M53.007 18.973A11.978 11.978 0 0 0 40.98 6.987c-6.642.022-12.027 5.425-12.027 12.068A11.978 11.978 0 0 0 40.98 31.04c6.643-.023 12.027-5.425 12.027-12.068Z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "save-orange_svg__a",
    x1: 75.984,
    x2: 12.433,
    y1: 48.789,
    y2: 48.928,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5BE60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5BE60",
    stopOpacity: 0.2
  })))));
};
export default SvgSaveOrange;